export enum AuthStep {
    Register = 'register',
    Login = 'login',
    ForgotPassword = 'forgot-password',
    SendCode = 'sen-code',
    NewPassword = 'new-password',
}
